import React, { useState } from "react";
import { useApp } from "@/context/AppContext";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Mail, MessageCircle, Loader2, CheckCircle2, Send } from "lucide-react";

export const NewsletterSignup = ({ variant = "footer" }) => {
  const { t, lang } = useApp();
  const n = t.newsletter;
  const [mode, setMode] = useState("email");
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { [mode]: value, lang });
      setDone(true); toast.success(data.status === "already_subscribed" ? n.already : n.success);
    } catch (err) { toast.error(apiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  const dark = variant === "footer";
  const inputCls = `flex-1 min-w-0 px-4 py-3 rounded-xl text-sm outline-none ${dark ? "bg-white/10 text-white placeholder:text-white/40 border border-white/15 focus:border-gold" : "bg-white border border-slate-200 focus:border-tigris"}`;

  return (
    <div data-testid="newsletter-signup" className={dark ? "" : "bg-tigris rounded-3xl p-6 sm:p-10 text-white"}>
      <h4 className={`font-bold mb-1 ${dark ? "text-gold" : "text-2xl sm:text-3xl font-display"}`}>{n.title}</h4>
      <p className={`text-sm mb-4 ${dark ? "text-slate-400" : "text-white/80 mb-6"}`}>{n.sub}</p>
      {done ? (
        <div data-testid="newsletter-success" className="flex items-center gap-2 text-sm font-semibold text-[#25D366]"><CheckCircle2 size={18} /> {n.success}</div>
      ) : (
        <form onSubmit={submit} className="space-y-3">
          <div className="flex gap-2">
            {["email", "whatsapp"].map((m) => (
              <button key={m} type="button" data-testid={`newsletter-mode-${m}`} onClick={() => { setMode(m); setValue(""); }}
                className={`px-3 py-1.5 rounded-full text-xs font-bold flex items-center gap-1.5 transition-colors ${mode === m ? "bg-gold text-white" : dark ? "bg-white/10 text-slate-300 hover:bg-white/20" : "bg-white/15 text-white hover:bg-white/25"}`}>
                {m === "email" ? <Mail size={13} /> : <MessageCircle size={13} />} {n[m]}
              </button>
            ))}
          </div>
          <div className="flex gap-2">
            <input data-testid="newsletter-input" type={mode === "email" ? "email" : "tel"} dir="ltr" required className={inputCls}
              placeholder={mode === "email" ? "name@example.com" : "07xx xxx xxxx"} value={value} onChange={(e) => setValue(e.target.value)} />
            <button type="submit" disabled={loading} data-testid="newsletter-submit" className="btn-gold px-4 py-3 rounded-xl font-bold text-sm flex items-center gap-1.5 shrink-0">
              {loading ? <Loader2 size={16} className="animate-spin" /> : <><Send size={15} /> {n.cta}</>}
            </button>
          </div>
          <p className={`text-[11px] ${dark ? "text-slate-500" : "text-white/60"}`}>{n.privacy}</p>
        </form>
      )}
    </div>
  );
};
